/* ============================================================
   NOVAA GEAR — in-drawer postcode delivery checker.
   Postcode → Metro / Regional / Remote zone → real shipping
   cost for the current cart, plus the zone's express price.

   Zone data = the Shopify shipping setup (metro_postcodes /
   remote_postcodes lists, 17 Jun 2026), compressed to ranges.
   Anything not metro/remote is Regional. Source of truth for
   the tiers: Novaa-Shipping-Policy.md —
     under $1,000: FREE Australia-wide (all zones)
     $1,000+: Metro FREE · Regional $49 · Remote $149
   No express price here (Locky, 10 Jul — declutter); checkout
   presents the zone express rate itself. If the tiers change,
   update SHIP below AND the Shopify rates together.

   MERGED BAR (10 Jul round 5): the shipping bar itself is the
   <details> wrap at $1,000+; the saved postcode's result
   replaces the bar message ([data-novaa-postcode-out] is the
   summary text) and the hint flips to "Change".

   The drawer re-renders on every cart change (morph), so a
   MutationObserver re-applies the saved postcode's result.
   ============================================================ */
(function () {
  'use strict';

  var METRO = '2000-2239,2555-2574,2600-2620,2740-2786,2900-2920,3000-3207,3335-3341,3427-3429,3750-3810,3910-3920,3926-3944,3975-3978,4000-4207,4300-4305,4500-4519,5000-5199,6000-6199';
  var REMOTE = '0852-0862,0870-0875,0880-0886,0906-0909,2898-2899,4470-4499,4720-4730,4800-4830,4871-4895,5650-5690,5710-5734,6431-6443,6600-6799,7151';

  var FREE_THRESHOLD = 100000; /* cents — carts under this ship free everywhere */
  var SHIP = { metro: 0, regional: 4900, remote: 14900 }; /* cents, at $1,000+ */
  var LABEL = { metro: 'Metro', regional: 'Regional', remote: 'Remote' };
  var KEY = 'novaa_postcode';

  function parseRanges(s) {
    return s.split(',').map(function (r) {
      var p = r.split('-');
      var lo = parseInt(p[0], 10);
      return [lo, p[1] ? parseInt(p[1], 10) : lo];
    });
  }
  var M = parseRanges(METRO);
  var R = parseRanges(REMOTE);

  function inRanges(n, rs) {
    for (var i = 0; i < rs.length; i++) {
      if (n >= rs[i][0] && n <= rs[i][1]) return true;
    }
    return false;
  }

  function zoneFor(pc) {
    var n = parseInt(pc, 10);
    if (isNaN(n) || n < 200 || n > 9999) return null;
    if (inRanges(n, M)) return 'metro';
    if (inRanges(n, R)) return 'remote';
    return 'regional';
  }

  function money(cents) {
    return cents === 0 ? 'FREE' : '$' + Math.round(cents / 100);
  }

  function stored() {
    try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; }
  }
  function store(pc) {
    try { localStorage.setItem(KEY, pc); } catch (e) { /* private mode */ }
  }

  function renderWrap(wrap) {
    var out = wrap.querySelector('[data-novaa-postcode-out]');
    var input = wrap.querySelector('input');
    var toggle = wrap.querySelector('[data-novaa-postcode-toggle]');
    var pc = stored();
    if (!out) return;
    if (!pc) return;
    var zone = zoneFor(pc);
    if (!zone) return;
    if (input && !input.value) input.value = pc;

    var total = parseInt(wrap.getAttribute('data-cart-total'), 10) || 0;
    var cost = total < FREE_THRESHOLD ? 0 : SHIP[zone];
    var text = pc + ' · ' + LABEL[zone] + ' — ' +
      (cost === 0 ? 'FREE shipping' : money(cost) + ' shipping');
    if (out.textContent !== text) out.textContent = text;
    out.classList.remove('is-error');
    out.classList.toggle('is-free', cost === 0);
    if (toggle && toggle.textContent !== 'Change') toggle.textContent = 'Change';
  }

  function renderAll() {
    var wraps = document.querySelectorAll('[data-novaa-postcode-wrap]');
    for (var i = 0; i < wraps.length; i++) renderWrap(wraps[i]);
  }

  /* Delegated submit — the drawer's innerHTML is morphed on every
     cart change, so never bind to the form node directly. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-novaa-postcode')) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var wrap = form.closest('[data-novaa-postcode-wrap]');
    var out = wrap && wrap.querySelector('[data-novaa-postcode-out]');
    var pc = input && input.value ? input.value.replace(/\D/g, '') : '';
    if (pc.length === 3) pc = '0' + pc; /* NT postcodes typed without the leading 0 */
    if (!/^\d{4}$/.test(pc) || !zoneFor(pc)) {
      if (out) {
        out.textContent = 'Enter a valid Australian postcode';
        out.classList.add('is-error');
        out.classList.remove('is-free');
      }
      return;
    }
    store(pc);
    if (input) input.value = pc;
    if (wrap && wrap.tagName === 'DETAILS') wrap.open = false; /* result shows in the bar */
    renderAll();
  }, true);

  function init() {
    renderAll();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () { renderAll(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
